import React, { Component } from 'react';
import './PortoRes.css';
import './Porto.css';

const Porto = () => {
    return ( 

        <>
        <h1 className='porfolioss'>Portfolio</h1>
        
        
        </>
     );
}
 
export default Porto;